import React from "react";
import { motion } from "framer-motion";
import "./ProductGrid.css";
import GridSlot from "./GridSlot";

export const gridContainerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.05,
    },
  },
};

export default function ProductGrid() {
  return (
    <motion.ul
      initial="hidden"
      animate="visible"
      variants={gridContainerVariants}
      className="product-grid"
    >
      {[0, 1, 2, 3, 4, 5, 6, 7].map((index) => {
        return <GridSlot key={index} index={index} />;
      })}
    </motion.ul>
  );
}
